/**
 * ACCS Site Entry Point
 * Imports the shared unified lead tracker and applies ACCS-specific configuration
 */

import siteConfig from './site-config'

// Import the shared unified lead tracker
// This imports from the shared /src/ directory (../../src/)
import '../../src/unified-lead-tracker'

// Log site configuration in debug mode
if (siteConfig.features?.debugMode) {
  console.log('🏢 ACCS Lead Tracker Initialized:', {
    brand: siteConfig.brand,
    displayName: siteConfig.displayName,
    features: siteConfig.features,
    version: process.env.NODE_ENV
  })
}

// Make site config available globally if needed for tracking
if (typeof window !== 'undefined') {
  (window as any).__SITE_CONFIG__ = siteConfig
}

// Export site config for access from shared code if needed
export { siteConfig }
